// extracted by mini-css-extract-plugin
export default {"modal-content":"StandardPopup_modal-content__s3RuG","modal-dialog":"StandardPopup_modal-dialog__k1w9X"};